<template>
  <v-main>
    <v-skeleton-loader v-if="isLoading" type="card" class="mx-auto" max-width="90%" />

    <v-row class="pt-2 ">
      <v-col cols="12">
        <span>Especifique un nuevo IBAN para que realicemos el ingreso:</span>
      </v-col>
      <v-col class="mx-auto" cols="11" md="10">

        <!-- INICIO FORMULARIO -->
        <v-form v-if="!isLoading" ref="form">

          <v-row class="pt-2">
            <v-col cols="12" sm="2" md="2">
              <v-text-field outlined ref="codigoPais" v-model="iban.codigoPais" :rules="[validationRules.required]"
                v-mask="'AA##'" label="Código país" counter="4" class="text-grey" style="font-size: 1.9em;"
                @input="handleInput('codigoPais', 'entidad')" />
            </v-col>

            <v-col cols="12" sm="2" md="2">
              <v-text-field outlined ref="entidad" v-model="iban.entidad" :rules="[validationRules.required]"
                v-mask="'####'" label="Entidad" counter="4" class="text-grey" style="font-size: 1.9em;"
                @input="handleInput('entidad', 'sucursal')" />
            </v-col>

            <v-col cols="12" sm="2" md="2">
              <v-text-field outlined ref="sucursal" v-model="iban.sucursal" :rules="[validationRules.required]"
                v-mask="'####'" label="Sucursal" counter="4" class="text-grey" style="font-size: 1.9em;"
                @input="handleInput('sucursal', 'digitoControl')" />
            </v-col>

            <v-col cols="12" sm="2" md="2">
              <v-text-field outlined ref="digitoControl" v-model="iban.digitoControl" :rules="[validationRules.required]"
                v-mask="'##'" label="D.C." counter="2" class="text-grey" style="font-size: 1.9em;"
                @input="handleInput('digitoControl', 'numeroCuenta')" />
            </v-col>

            <v-col cols="12" sm="4" md="4">
              <v-text-field outlined ref="numeroCuenta" v-model="iban.numeroCuenta" :rules="[validationRules.required]"
                v-mask="'##########'" label="Número de cuenta" counter="10" class="text-grey" style="font-size: 1.9em;" />
            </v-col>
          </v-row>

        </v-form>
      </v-col>
    </v-row>

  </v-main>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import StepBase from './StepBase'

export default {
  name: 'DatosBancariosMain',
  mixins: [StepBase],
  components: {

  },
  data() {
    return {
      stepId: 'DATOS_BANCARIOS',
      isLoading: false,
      iban: {
        codigoPais: null,
        entidad: null,
        sucursal: null,
        digitoControl: null,
        numeroCuenta: null,
      },
    }
  },
  computed: {
    ibanConcatenado() {
      return Object.values(this.iban).join('');
    }
  },
  props: {
    ibanPropuesto: { type: Object, required: false, default: () => { } },
  },

  methods: {
    loadIban() {
      this.isLoading = true
      Object.assign(this.iban, this.ibanPropuesto);
      this.isLoading = false
    },
    /**
     * Se ejecuta al introducir datos en el componente field y
     * al cumplir la longitud máxima definida en la propiedad counter
     * cambia el focus al componente declarado en la propiedad nextField
     */
    handleInput(field, nextField) {
      try {
        if (this.iban[field].length == this.$refs[field].$options.propsData.counter) {
          this.$refs[nextField].$refs.input.focus();
        }
      } catch (error) {
        return;
      }
    },
  },

  mounted() {
    if (this.ibanPropuesto && Object.keys(this.ibanPropuesto).length > 0) {
      this.loadIban()
    }
  }
}
</script>